import React from "react";
import ReactSelect, { Props as SelectProps } from "react-select";

type TSelect = SelectProps & {};

export default ({ ...props }: TSelect) => {
  return (
    <ReactSelect
      styles={{
        container: provided => ({ ...provided, width: 250, zIndex: 10 }),
        indicatorSeparator: () => ({})
      }}
      {...props}
    />
  );
};
